module.exports = __webpack_public_path__ + "img/4sdian.c0326866.png";